import styled from "@emotion/styled";
import { Link as RouterLink } from "react-router";
import {
  RADII,
  FONT_WEIGHT,
  FONT_SIZE,
  BUTTON_SECONDARY_COLOR,
  COLOR_PRIMARY,
  MOBILE_SCREEN,
  COLOR_INPUT_DEFAULT_BORDER,
  COLOR_INPUT_BORDER_HOVER,
  COLOR_INPUT_BORDER_FOCUSED,
  COLOR_SECONDARY_BUTTON_DISABLED_BORDER,
  COLOR_SECONDARY_BUTTON_DISABLED_TEXT,
  buttonText,
} from "../theme";

export const SecondaryButton = styled.button`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 16px 32px;
  border-radius: ${RADII.pill};
  color: ${COLOR_PRIMARY};
  background-color: ${BUTTON_SECONDARY_COLOR};
  ${buttonText}
  text-align: center;
  cursor: pointer;
  flex-shrink: 0;
  border: 1px solid ${COLOR_INPUT_DEFAULT_BORDER};
  transition: all 100ms ease-in-out;
  &:disabled {
    border: 1px solid ${COLOR_SECONDARY_BUTTON_DISABLED_BORDER};
    color: ${COLOR_SECONDARY_BUTTON_DISABLED_TEXT};
    cursor: not-allowed;
  }
  &:hover:not(:disabled):not(:focus) {
    border: 1px solid ${COLOR_INPUT_BORDER_HOVER};
  }
  &:focus {
    border: 1.5px solid ${COLOR_INPUT_BORDER_FOCUSED};
  }
  ${MOBILE_SCREEN} {
    gap: 8px;
  }
`;

export const SecondaryButtonLink = styled(
  SecondaryButton.withComponent(RouterLink),
)`
  text-decoration: none;
`;

export const SecondaryButtonSmall = styled(SecondaryButton)`
  font-size: ${FONT_SIZE.md};
  height: 40px;
  font-weight: ${FONT_WEIGHT.medium};
  padding: 3px 16px;
  gap: 8px;
`;

/** Router-link counterpart of the Figma small secondary button (40px / medium). */
export const SecondaryButtonSmallLink = styled(
  SecondaryButtonSmall.withComponent(RouterLink),
)`
  text-decoration: none;
`;

export const SecondaryButtonSmallNormalWeight = styled(SecondaryButtonSmall)`
  font-weight: ${FONT_WEIGHT.regular};
`;
